export default __webpack_public_path__ + "static/media/desk.865fb5f7.png";